<template>
  <div class="container">
    <div class="header">
        <span @click="onClickLeft" style="color:#fff;font-size:30px;position:absolute;left:6px;top:20px">〈</span>
        <img src="../../assets/images/company-log.png" alt="">
    </div>
    <div class="swiper">
        <img :src="images.imageSrc1" alt="">
    </div>
    <div class="title">欢迎志同道合的朋友咨询加盟！</div>
    <div class="submit-info">
        <van-field v-model="submitParam.name" placeholder="*姓名" />
        <van-field v-model="submitParam.phone" placeholder="*电话" />
        <van-field v-model="submitParam.wechat" placeholder="*微信" />
        <div class="consultation" @click="submitQuestion">招生与合作咨询</div>
    </div>
    <div class="admission-process suitable-crowd school">
        <img :src="images.imageSrc2" alt="">
    </div>
    <div class="admission-process certification-authority">
        <img :src="images.imageSrc3" alt="">
    </div>
    <div class="admission-process excellent-course">
        <img :src="images.imageSrc4" alt="">
    </div>
    <div class="admission-process suitable-crowd">
        <img :src="images.imageSrc5" alt="">
    </div>
    <div class="submit-info">
         <van-field v-model="submitParam.name" placeholder="*姓名" />
         <van-field v-model="submitParam.phone" placeholder="*电话" />
         <van-field v-model="submitParam.wechat" placeholder="*微信" />
         <div class="consultation" @click="submitQuestion">招生与合作咨询</div>
    </div>
    <div class="footer">
      <div class="company-info">
        <span>地址 ：深圳市南山区桃花园路8号田厦国际中心A座2406/2408/2409/2410</span>
        <span>电话 ：0755-82947408（咨询热线）   0755-88379747（合作热线）</span>
        <span>网址 ：http://www.china-aiei.com</span>
        <span>邮箱 ：ymword@china-aiei.com</span>
      </div>
      <div class="dingbu">
        <img src="../../assets/images/Abundance.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import * as Apis from '@/apis'
import { Toast } from 'vant'
import {  Message } from 'element-ui'
import Axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  name: 'education',
    data () {
        return {
            queryId: '',
            // 学位项目列表
            submitParam: {
                name: '',
                phone: '',
                wechat: ''
            },
            images: {
                imageSrc1: '',
                imageSrc2: '',
                imageSrc3: '',
                imageSrc4: '',
                imageSrc5: ''
            },
            appId:'',
            timestamp:'',
            ul:'',
        }
    },
    mounted(){
        var ul = window.location.href.split("#")[0]
        Axios.get('http://159.138.89.136:9000/apitest/signature',{
        params:{
          us : ul,
          id: this.queryId
        }
      }).then(res => {
        console.log(res.data)
        wx.config({           
            debug: false, // 开启调试模式,开发时可以开启                  
            appId:"wx8a5bb93568fc82e8",  //appId: res.appId,   // 必填，公众号的唯一标识   由接口返回
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳 由接口返回
            nonceStr: res.data.nonceStr,    // 必填，生成签名的随机串 由接口返回
            signature: res.data.signature,   // 必填，签名 由接口返回
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'wx.onMenuShareWeibo','wx.onMenuShareTimeline'] // 此处填你所用到的方法
        });      
        wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({ 
                title: res.data.title, // 分享标题
                desc: res.data.desc, // 分享描述
                //link: 'http://degree.chinaaiei.com/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                //link: window.location.href.split("#")[0]+"/education?id="+this.queryId,
                link: res.data.link,
                imgUrl: res.data.imgUrl, // 分享图标
                success: function () {
                // 设置成功
                }
            });
            wx.updateTimelineShareData({ 
                title: res.data.title, // 分享标题
                link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: res.data.imgUrl, // 分享图标
                success: function () {
                // 设置成功
            }
            });
            // wx.onMenuShareTimeline({ 
            //     title: res.data.title, // 分享标题
            //     link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //     imgUrl: res.data.imgUrl,// 分享图标
            //     success: function () {
            //     设置成功
            //     }
            // })               
        });
     }).catch((error) => {
        console.log(error);//异常
        });
    },
    // created(){
    //     var ul = window.location.href.split("#")[0]
    //     Axios.get('http://159.138.86.225:8000/apitest/signature',{
    //     params:{
    //       us : ul,
    //       id: this.queryId
    //     }
    //   }).then(res => {
    //       wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    //         wx.updateAppMessageShareData({ 
    //             title: res.data.title, // 分享标题
    //             desc: res.data.desc, // 分享描述
    //             //link: 'http://degree.chinaaiei.com/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //             //link: window.location.href.split("#")[0]+"/education?id="+this.queryId,
    //             link: res.data.link,
    //             imgUrl: res.data.imgUrl, // 分享图标
    //             success: function () {
    //             // 设置成功
    //             }
    //         });
    //         // wx.updateTimelineShareData({ 
    //         //     title: res.data.title, // 分享标题
    //         //     link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //         //     imgUrl: res.data.imgUrl, // 分享图标
    //         //     success: function () {
    //         //     // 设置成功
    //         // }
    //         // });
    //         wx.onMenuShareTimeline({ 
    //             title: res.data.title, // 分享标题
    //             link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //             imgUrl: res.data.imgUrl,// 分享图标
    //             success: function () {
    //             // 设置成功
    //             }
    //         })               
    //     });
    //   }
    //   ).catch((error) => {
    //     console.log(error);//异常
    //     });
    //   }, 
    methods: {
        // 返回
        onClickLeft() {
            this.$router.go(-1)
        },
        // async getwxshare(){
        //     const self = this
        //     const {
        //         success,
        //         data,
        //         message
        //     // } = await Apis.wxshare()
        //     } = await Apis.wxshare()
        // if (success) {
        //     const info = data
        //     self.date = info
        //     wx.config({
        //              debug: true, // 开启调试模式,开发时可以开启
        //              appId: self.data.appId,   // 必填，公众号的唯一标识   由接口返回
        //             timestamp: self.data.timestamp, // 必填，生成签名的时间戳 由接口返回
        //             nonceStr: self.data.nonceStr,    // 必填，生成签名的随机串 由接口返回
        //             signature: self.data.signature,   // 必填，签名 由接口返回
        //             jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'wx.onMenuShareWeibo'] // 此处填你所用到的方法
        //          });
        //     console.log(self.data)
        // } else {
        //     Message.error(message)
        //  }
        // },
        async getEducatonImage() {
            const self = this
            const {
                success,
                data,
                message
            } = await Apis.degreeItem({id: self.queryId})
            if (success) {
                const info = data.degreeList
                self.images.imageSrc1 = info[0].src1
                self.images.imageSrc2 = info[0].src2
                self.images.imageSrc3 = info[0].src3
                self.images.imageSrc4 = info[0].src4
                self.images.imageSrc5 = info[0].src5
            } else {
                Message.error(message)
            }
        },
        async submitInfomation() {
            const { name, phone, wechat } = this.submitParam
            const self = this
            const {
                success,
                data,
                message
            } = await Apis.submitInfo({
                name:name,
                ph: phone,
                xm: wechat,
                id: self.queryId
            })
            if (success) {
                Toast('提交成功！')
            } else {
                Message.error(message)
            }
        },
        submitQuestion() {
            const { name, phone } = this.submitParam
            const reg = /^1(3|5|6|7|8|9)\d{9}$/
            if (!name) {
                return Toast('请输入姓名！')
            } else if (!phone) {
                return Toast('请输入手机号！')
            } else if (!reg.test(phone)) {
                return Toast('请输入正确的手机号')
            } else {
                this.submitInfomation()
            }
        }
    },
    created() {
        this.queryId = this.$route.query.id
        this.getEducatonImage()
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.container {
  width 100%
  overflow hidden
  .header {
    background #EF862F
    width 100%
    padding 17px 0
    img {
        display block
        height 100px
        width 340px
        margin 0 auto
    }
  }
  .swiper {
     width 100%
     overflow hidden
     img {
         width 100%
     }
  }
  .title{
      width 100%
      height 40px
      font-size 40px
      margin-top 24px
      text-align center
      color #F0862F
  }
  .consultation{
      width 500px
      height 56px
      border-radius 5px
      background #F0862F
      text-align center
      color #fff
      margin 30px auto 0
      font-size 24px
      line-height 56px
      margin-right: 6px
  }
//    入学流程
  .admission-process{
      width 100%
      padding 19px 0 28px
      box-sizing border-box
      img {
          width 100%
      }
      .process-title{
          width 522px
          height 37px
          background-size 522px 23px
          margin 0 auto 15px
          text-align center
          color #fff
          font-size 37px
          box-sizing border-box
          background-position-y 7px
      }
      .under-line{
          width 99px
          height 2px
          background #fff
          margin 0 auto 13px
      }
      .process-English{
          overflow hidden
          text-align center
          height 24px
          margin 0 auto 17px
          font-size 24px
          color #fff
      }
      .process-class{
          width 100%
          height 140px
          display flex
          justify-content space-around
      }
      .process-class-bg{
          width 121px
          background-size 100% 100%
          .process-class-small{
              width 35px
              height 35px
              margin 7px auto
              img{
                  width 100%
                  height 100%
              }
          }
          span{
              font-size 19px
              color #000
              text-align center
              line-height 29px
              display inline-block
              width 100%
              margin-top 20px
              padding 0 10px
              box-sizing border-box
          }
      }

  }
//  适读人群
  .suitable-crowd ,.certification-authority{
      width 100%
      background #fff
      .suitable-title{
          color #F0862F
          background-size 522px 23px
          margin 15px auto 15px
          background-position-y 7px
      }
      .suitable-line{
          background #F0862F
      }
      .suitable-English{
          overflow hidden
          color #F0862F
          margin 0 auto 29px
      }
      .suitable-desc{
          width 670px
          height 130px
          background #fff
          border-radius 15px
          box-shadow 0 5px 10px #D2D1D1
          margin 0 auto
          padding 25px
          box-sizing border-box
          .suitable-text{
              width 100%
              height 100%
              font-size 16px
              line-height 28px
              overflow hidden
              text-overflow ellipsis
          }
      }
  }
//    精品课程
  .excellent-course{
      width 100%
      padding 26px 0
      box-sizing border-box
      .excellent-English{
          overflow hidden
      }
      .excellent-table{
          width 595px
          height 304px
          margin 0 auto
          border 2px solid #fff
          font-size 14px
          line-height 38px
          .excellent-td{
              width 295px
              text-align center
              border-right 2px solid #fff
              border-bottom 2px solid #fff
              float left
              color #fff
          }
          .excellent-td:nth-child(2n){
              border-right 0
          }
          .excellent-td:last-child{
              width 100%
              border 0
              overflow hidden
              height 100px
              line-height 35px
          }
      }
  }
//   权威认证
   .certification-authority{
       .authority-English{
           overflow: hidden;
           color #F0862F
       }
       .authority-desc{
           width 628px
           height 100px
           margin 0 auto 20px
           position relative
           .authority-img{
               position absolute
               top: 0
               left 0
               width 108px
               height 108px
               margin-right 22px
               z-index 2
               img{
                   width 100%
                   height 100%
               }
           }
           .authority-text{
               width 533px
               height 106px
               font-size 16px
               line-height 42px
               background #fff
               box-shadow 0 5px 10px #D2D1D1
               position absolute
               right 0
               top 0
               border-radius 15px
               overflow hidden
               padding 19px 26px 0 19px
               box-sizing border-box
           }
       }
   }
//院校介绍
  .school {
      .school-desc{
          width 100%
          padding 0 15px
          box-sizing border-box
          overflow hidden
          display flex
          .school-desc-img{
              width 282px
              height 256px
              background-size 100% 100%
              box-shadow 0 10px 10px #D2D1D1
              margin-right 18px
              float left
          }
          .school-desc-text{
              flex 1
              text-indent 2em
              height 256px
              background #fff
              box-shadow 0 10px 10px #D2D1D1
              float left
              border-radius 15px
              overflow hidden
              line-height 38px
              font-size 14px
              padding 20px 12px
              box-sizing border-box
          }
      }
  }
  .footer {
    margin-top 40px
    padding 14px
    background #F0862F
    color #fff
    display flex
    box-sizing border-box
    .company-info {
      flex 1
      padding 16px 0px 16px 30px
      span {
        display block
        font-size 14px
        line-height 36px
        }   
    }
    .dingbu {
        position absolute
        img {
        display block
        height 120px
        width 120px
        padding-left  580px
        padding-top  40px
        //margin-top  100px
        //margin-left   550px
      }
    }
  }
}
</style>
<style lang="stylus">
.van-swipe__indicators {
  display none !important
}
.submit-info {
    width 508px
    margin 0 auto 30px
    .van-cell {
        width 500px
        height 56px
        padding 0 0 0 18px
        border 1px solid #F0862F
        border-radius 8px
        line-height 54px
        margin-top 30px
    }
}
</style>
